import { HsGeometryData } from './geometry-data.class';

/**
 * Handles s indexed geometry data.
 */
export class HsIndexedGeometryData extends HsGeometryData {
  constructor(
    vertices: ArrayLike<number>,
    normals: ArrayLike<number>,
    public indices: ArrayLike<number>,
    uvs?: ArrayLike<number>
  ) {
    super(vertices, normals, uvs);
  }
}
